
import { useFriendshipState } from './useFriendshipState';
import { useFriendshipActions } from './useFriendshipActions';

/**
 * Combined hook that provides all friendship functionality
 */
export const useFriendships = () => {
  const {
    friends,
    pendingRequests,
    sentRequests,
    isLoading,
    refreshFriendships
  } = useFriendshipState();

  const {
    sendFriendRequest,
    acceptFriendRequest,
    rejectFriendRequest,
    removeFriend,
    createManualFriend,
    updateManualFriend,
    removeManualFriend,
    isProcessing
  } = useFriendshipActions(refreshFriendships);

  return {
    // State
    friends,
    pendingRequests,
    sentRequests,
    isLoading,

    // Actions
    sendFriendRequest,
    acceptFriendRequest,
    rejectFriendRequest,
    removeFriend,
    createManualFriend,
    updateManualFriend,
    removeManualFriend,

    // Utilities
    refreshFriendships,
    isProcessing
  };
};
